/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Video_TitleInputs */

const en_subscription_video_title = /** @type {(inputs: Subscription_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forest Plus`)
};

const ar_subscription_video_title = /** @type {(inputs: Subscription_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forest Plus`)
};

const de_subscription_video_title = /** @type {(inputs: Subscription_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forest Plus`)
};

const es_subscription_video_title = /** @type {(inputs: Subscription_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forest Plus`)
};

const fr_subscription_video_title = /** @type {(inputs: Subscription_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forest Plus`)
};

const it_subscription_video_title = /** @type {(inputs: Subscription_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forest Plus`)
};

const ja_subscription_video_title = /** @type {(inputs: Subscription_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forest Plus`)
};

const ko_subscription_video_title = /** @type {(inputs: Subscription_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forest Plus`)
};

const pt_br_subscription_video_title = /** @type {(inputs: Subscription_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forest Plus`)
};

const ru_subscription_video_title = /** @type {(inputs: Subscription_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forest Plus`)
};

const th_subscription_video_title = /** @type {(inputs: Subscription_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forest Plus`)
};

const tr_subscription_video_title = /** @type {(inputs: Subscription_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forest Plus`)
};

const zh_cn_subscription_video_title = /** @type {(inputs: Subscription_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forest Plus`)
};

const zh_tw_subscription_video_title = /** @type {(inputs: Subscription_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forest Plus`)
};

/**
* | output |
* | --- |
* | "Forest Plus" |
*
* @param {Subscription_Video_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_video_title = /** @type {((inputs?: Subscription_Video_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Video_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_video_title(inputs)
	if (locale === "ar") return ar_subscription_video_title(inputs)
	if (locale === "de") return de_subscription_video_title(inputs)
	if (locale === "es") return es_subscription_video_title(inputs)
	if (locale === "fr") return fr_subscription_video_title(inputs)
	if (locale === "it") return it_subscription_video_title(inputs)
	if (locale === "ja") return ja_subscription_video_title(inputs)
	if (locale === "ko") return ko_subscription_video_title(inputs)
	if (locale === "pt_br") return pt_br_subscription_video_title(inputs)
	if (locale === "ru") return ru_subscription_video_title(inputs)
	if (locale === "th") return th_subscription_video_title(inputs)
	if (locale === "tr") return tr_subscription_video_title(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_video_title(inputs)
	return zh_tw_subscription_video_title(inputs)
});